export function infoCacheLog(...msgs: any[]) {
  console.log(
    `%c${msgs.map((msg) => `${msg}`).join(" ")}`,
    "color:#333;font-weight:bold;"
  );
}
export function infoCacheLogBlue(...msgs: any[]) {
  console.log(
    `%c${msgs.map((msg) => `${msg}`).join(" ")}`,
    "color:#4260C2;font-weight:bold;"
  );
}
export function infoCacheLogReddish(...msgs: any[]) {
  console.log(
    `%c${msgs.map((msg) => `${msg}`).join(" ")}`,
    "color:#8C1F00;font-weight:bold;"
  );
}
export function infoCacheLogGreen(...msgs: any[]) {
  console.log(
    `%c${msgs.map((msg) => `${msg}`).join(" ")}`,
    "color:#008C27;font-weight:bold;"
  );
}
export function infoCacheLogSubtle(...msgs: any[]) {
  console.log(`%c${msgs.map((msg) => `${msg}`).join(" ")}`, "color:#42A0C2");
}
export function failedCacheLog(...msgs: any[]) {
  console.log(
    `%c${msgs.map((msg) => `${msg}`).join(" ")}`,
    "color:#FF3333;font-weight:bold;"
  );
}
export function successCacheLog(...msgs: any[]) {
  console.log(
    `%c${msgs.map((msg) => `${msg}`).join(" ")}`,
    "color:#42C264;font-weight:bold;"
  );
}
